import { useState } from "react";
import PageTitle from "../components/PageTitle";
import { useMe } from "../context/MeContext";
import { Company } from "../types/Me";
import AnalyticsHome from "../components/Analytics/AnalyticsHome";
import { Outlet } from "react-router-dom";
import AdminAnalyticsHome from "./Admin/Analytics/AdminAnalyticsHome";
import BackButton from "../components/BackButton";

export default function AnalyticsPage() {

    const {me, refreshMe, isAdmin} = useMe();
    const [organisation, setOrganisation] = useState<Company|null>(null);

    return (
        <>
        <BackButton />
            <PageTitle>Analytics</PageTitle>
            {isAdmin ? (
                <AdminAnalyticsHome />
            ) : (
                <AnalyticsHome />
            )}
        </>
        
    )
}